/**
 * @fileoverview Default configuration for the app.
 */
export const defaultConfig = {
  projectName: "My Project",
  globalCost: 50, // default EUR per hour
  showGroups: true,
  showPhases: true,
  language: "en", // default language
};
